<template>

  <div class="banner">
    <div class="title">
      <span v-if="isAuthenticated">
        <p class="storename" v-if="isEnterpriseAdmin && !isEnterpriseReportPage">{{ storename }} </p>
        <h2 v-show="isVINScannerPage">VIN Scanner</h2>
        <h2 v-show="isDVIPage">Digital Vehicle Inspection</h2>
        <h2 v-show="isReportingPage">Reporting</h2>
        <!-- Enterprise Report Page -->
        <h2 v-show="isEnterpriseAdmin && isEnterpriseReportPage">Enterprise Reports</h2>
      </span>
      <!-- For DVI Results Page -->
      <span v-else>
        <h2 v-show="isDVIPage">Digital Vehicle Inspection</h2>
      </span>
    </div>
    <div class="signature">
      <p>Powered by</p>
      <img class="logo" src="../assets/img/protractor_logo_rev.svg" alt="Protractor">
    </div>
  </div>

</template>

<script lang="ts" setup>
import { useAuth0 } from '@auth0/auth0-vue';
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const store = useStore();
const router = useRouter();
const auth0 = useAuth0();
const isAuthenticated = ref(auth0.isAuthenticated);
const storename = computed(() => store.state.storename);
const user = ref(auth0.user);
const userRole = computed(() => user.value['http://protractor.com/role']);

const dvipages = ['/dviworkorders', '/dviworkorderpackages', '/dviupdateworkorderpackage', '/dvisummaryworkorderpackage', '/results.html'];
const vinscannerpages = ['/workorders', '/updateorder'];
const reportingpages = ['/reporting', '/reports'];
const enterprisereportpages = ['/enterprise'];

const isVINScannerPage = computed(() => vinscannerpages.includes(router.currentRoute.value.path));
const isDVIPage = computed(() => dvipages.includes(router.currentRoute.value.path));
const isReportingPage = computed(() => reportingpages.includes(router.currentRoute.value.path));
const isEnterpriseReportPage = computed(() => enterprisereportpages.includes(router.currentRoute.value.path));
const isEnterpriseAdmin = computed(() => userRole.value === 'EnterpriseAdmin');
</script>
